export const useGlobalTranslations = {
  pt: {
    loading: 'A carregar...',
    orderSuccess: 'Pedido realizado com sucesso!',
    orderError: 'Ocorreu um erro ao realizar o pedido.',

    somethingWentWrong: 'Algo correu mal',
    tryAgainLater: 'Por favor tente mais tarde',
    errorOccurred: 'Ocorreu um erro',
    tryAgain: 'Tentar novamente',
    content: 'Conteúdo',

    signInOrCreate: 'Inicie sessão ou crie uma conta',
    signInOrCreateDescription: 'Guarde os seus produtos favoritos, métodos de pagamento, moradas de envio e muito mais!',
    vehiclesAdded: 'Veículos adicionados',

    addToFavouritesTitle: 'Erro ao adicionar aos favoritos',

    incorrectPassword: 'Palavra passe incorreta',
    enterEmailAndPasswordCorrectly: 'Introduza o email e a palavra passe de forma correta.',

    myAccount: 'A minha conta',
    createAnAccount: 'Criar conta',
    accountDoesNotExist: 'Conta não existente',
    emaildDoesNotExist: 'O e-mail introduzido não corresponde a uma conta existente. Clique em Registar ou use Google, Facebook ou Apple para entrar.',

    alreadyExistingEmail: 'Email já existente',
    alreadyRegisteredEmail: 'O email introduzido já se encontra registado. Verifique se já tem conta com uma das outras opções (Google, Facebook ou Apple).',

    networkError: 'Erro de rede',
    makeSureConnectedToInternet: 'Certifica-te que estás ligado à internet. Se o problema persistir tenta novamente mais tarde.',
    mbwayMandateError: 'Não foi possível adicionar este número aos pagamentos autorizados MB WAY.',

    accountAlreadyExists: 'Conta já existente',
    accountAlreadyExistsLoginThere: 'Já existe uma conta associada a outra opção de login. Por favor, faça login nessa outra conta.',

    invalidCode: 'Código inválido',
    codeNotValidatedTryAgain: 'O código introduzido é inválido. Por favor, tente novamente.',
    invalidPostalCode: 'Código postal inválido',
    invalidEmail: 'Email inválido',

    loginAgain: 'Entrar novamente',
    thisActionRequiresARecentLogin: 'Esta ação requer que faça login novamente.',

    popUpClosedByUser: 'A janela foi fechada pelo utilizador.',
    accessCredentialsAlreadyInUseByAnotherAccount: 'Credenciais de acesso já em uso por outra conta.',
    phoneNumberAlreadyInUseByAnotherAccount: 'Número de telemóvel já em uso noutra conta',

    smsCodeExpired: 'Código SMS expirado',
    smsCodeExpiredTryAgain: 'O código SMS expirou. Por favor, peça um novo e tente novamente.',

    tooManyRequests: 'Demasiados pedidos',
    tooManyRequestsTryAgainLater: 'Bloqueámos todos os pedidos deste dispositivo devido a atividade suspeita. Tente novamente mais tarde.',

    invalidPhoneNumber: 'Número de telefone inválido',
    invalidPhoneNumberTryAgain: 'O número de telefone introduzido é inválido. Por favor, verifique se inseriu o número correto e tente novamente.',

    unsupportedNumber: 'Número não suportado',
    mobileNumberCountryNotSupported: 'Lamentamos, mas o número de telemóvel deste país ainda não é suportado.',

    name: 'Nome',
    phoneNumber: 'Nº de telemóvel',
    phone: 'Telemóvel',
    password: 'Palavra passe',
    forgotPassword: 'Esqueci-me da palavra passe',
    insertValidName: 'Insira um nome válido',
    insertValidEmail: 'Insira um email válido',
    insertValidPhoneNumber: 'Insira um número de telemóvel válido',
    password6Characters: 'A palavra-passe deve ter pelo menos 6 carateres',
    validUntil: 'Válido até',
    until: 'Até',
    workingDays: 'Dias úteis',
    onTheBasket: 'No cesto',

    terms1: 'Li e aceito os &lt;span&gt;Termos e condições&lt;/span&gt; de utilização da aplicação miio.',
    terms2: 'Li, compreendo e aceito as condições de &lt;span&gt;utilização da rede de mobilidade elétrica&lt;/span&gt;.',
    terms3: 'Li, compreendo e aceito as condições gerais de &lt;span&gt;fornecimento de eletricidade&lt;/span&gt; para a mobilidade elétrica da miio.',

    countryOfResidence: 'País de residência',
    yourData: 'Os seus dados',
    hello: 'Olá',
    image: 'Imagem',
    changeImage: 'Alterar imagem',
    start: 'Início',
    end: 'Fim',
    attention: 'Atenção',
    warning: 'Aviso',

    enter: 'Entrar',
    confirm: 'Confirmar',
    confirmation: 'Confirmação',
    close: 'Fechar',
    closed: 'Fechado',
    cancel: 'Cancelar',
    cancelChange: 'Cancelar alteração',
    keepChange: 'Manter alteração',
    search: 'Pesquisar',
    clear: 'Limpar',
    apply: 'Aplicar',
    change: 'Alterar',
    status: 'Estado',
    back: 'Voltar',
    backToHomePage: 'Voltar à página inicial',
    advance: 'Avançar',
    add: 'Adicionar',
    or: 'ou',
    country: 'País',
    locality: 'Localidade',
    postalCode: 'Código postal',
    address: 'Morada',
    number: 'Número',
    batch: 'Lote',
    optional: 'Opcional',
    options: 'Opções',
    saveAsDefault: 'Guardar como predefinida',
    addNewAddress: 'Adicionar nova morada',
    shippingAddress: 'Morada de envio',
    savedAddresses: 'Moradas guardadas',
    defaultAddress: 'Morada predefinida',
    addShippingAddress: 'Adicionar morada de envio',
    vatAddress: 'Morada de faturação',
    sameAsShippingAddress: 'A morada de faturação é a mesma do envio',
    noAddressesAdded: 'Ainda não tem moradas adicionadas',
    vat: 'NIF',
    vatNumber: 'Número de contribuinte',
    errorNoAddressOnAccount:
      'Não é possível usar a mesma morada de envio como de faturação sem nome ou email definido na conta miio. Por favor, atualize as informações da sua conta ou crie uma morada de faturação manualmente.',
    addShippingError: 'Não foi possível associar as informações de envio. Por favor tente novamente.',
    payment: 'Pagamento',
    doPayment: 'Efetuar pagamento',
    goToPayment: 'Avançar para pagamento',
    paymentMethods: 'Métodos de pagamento',
    addNewMethod: 'Adicionar novo método',
    noPaymentMethods: 'Ainda não tem métodos de pagamento adicionados',
    invoiceName: 'Nome na fatura',
    wantToBeInvoicedAsFinalConsumer: 'Quero fatura sem NIF',
    invoiceAsFinalConsumer: 'Quero ser faturado como consumidor final',
    invoicingEmail: 'Email de faturação',
    streetOrAvenue: 'Rua ou Avenida',
    fillAllFields: 'Por favor, preencha todos os campos assinalados com *',
    fromPrice: 'Desde',
    continue: 'Continuar',
    yes: 'Sim',
    no: 'Não',
    help: 'Ajuda',
    faq: 'Perguntas frequentes',
    speakWithMiio: 'Falar com a miio',

    login: 'Iniciar sessão',
    register: 'Registar',
    month: 'Mês',
    year: 'Ano',

    basket: 'Cesto',
    resume: 'Resumo',
    compatible: 'Compatível',
    addToBasket: 'Adicionar ao cesto',
    notAvailable: 'Indisponível',
    points: 'Pontos',
    favourites: 'Favoritos',
    quantity: 'Quantidade',
    yourRequest: 'O seu pedido',
    helpContactSubject: 'Ajuda com o pedido #{id}',
    contactSupport: 'Contactar apoio ao cliente',

    allProducts: 'Todos os produtos',
    suggestions: 'As nossas sugestões',
    bestsellers: 'Os mais vendidos',
    recentlySeen: 'Vistos recentemente',
    viewMore: 'Ver mais',
    viewLess: 'Ver menos',
    commentUsefulToPeople: 'Isto parece ter sido útil a {votes} pessoas',
    loadMoreReviews: 'Carregar mais avaliações',
    loadPreviousProducts: 'Ver produtos anteriores',
    loadMoreProducts: 'Carregar mais produtos',
    useful: 'Útil',
    mostUseful: 'Mais úteis',
    mostRecent: 'Mais recentes',
    ratings: 'Avaliações',
    viewResults: 'Ver resultados',
    viewDetails: 'Ver detalhes',
    chargingPreferences: 'Preferências de carregamento',
    aboutUs: 'Sobre nós',
    value: 'Valor',

    products: 'Produtos',
    noProducts: 'Sem produtos',
    noCategories: 'Sem categorias',
    noRatings: 'Sem avaliações',
    refreshPage: 'Atualize a página para tentar novamente',
    categories: 'Categorias',
    filters: 'Filtros',
    bestseller: 'Mais vendidos',
    recommended: 'Recomendados',
    recommendedSingular: 'Recomendado',
    priceAsc: 'Preço: Menor para maior',
    priceDesc: 'Preço: Maior para menor',
    priceWithoutDiscount: 'Preço sem desconto',
    order: 'Ordenar',
    orderBy: 'Ordenar por',
    compare: 'Comparar',
    compareProducts: 'Comparar produtos',
    update: 'Atualizar',
    nothingHere: 'Não há nada aqui',
    noCategoryProducts: 'Ainda não há produtos nesta categoria.',
    knowProductComments: 'Para saber o que a comunidade diz deste produto, clique abaixo.',
    problemLoadingProduct: 'Houve um problema ao carregar o produto.',
    loadingCompareNotPossible: 'Não foi possível carregar as comparações.',
    upsResultNotFound: 'Ups, nenhum resultado encontrado.',
    removeSearchKeywords: 'Tente remover algumas das palavras-chave para ver mais resultados.',
    emptyBasket: 'O seu cesto está vazio',
    emptyBasketDescription: 'Adicione produtos para aparecerem aqui.',
    nothingToSeeHere: 'Por enquanto, não há nada para ver aqui',
    addProductsToFavourites: 'Adicione produtos à sua lista de favoritos para acesso rápido.',
    noOrdersPlaceholder: 'Assim que fizeres compras, iremos guardar um registo das mesmas aqui.',

    timeToRecharge: 'Tempo para carregar',
    chargingFrom20to80: 'O tempo de carga é referente a 20% a 80% da bateria',
    inStock: 'Em stock',
    lastUnits: 'Últimas unidades',
    limitedStock: 'Stock limitado a {units} unidades, reveja a quantidade para prosseguir.',
    remindMeWhenAvailable: 'Avise-me quando estiver disponível',
    willBeNotifiedWhenAvailable: 'Irá ser notificado assim que este produto voltar a estar disponível.',
    remindMe: 'Avisar-me',
    youCouldLike: 'Também poderá gostar de:',
    description: 'Descrição',
    technicalDetails: 'Ficha técnica',
    additionalInfo: 'Informações adicionais',
    reviews: 'Avaliações',
    historic: 'Histórico',
    report: 'Reportar',
    reportReview: 'Reportar avaliação',
    couponSuccess: 'Cupão aplicado com sucesso!',
    couponError: 'Este cupão não é válido ou expirou.',

    shippingDateAprox: 'Previsão de entrega para {country}:',
    chooseDateToViewShippingDate: 'Escolha as especificações do produto para ver uma previsão de entrega mais precisa.',
    chooseProductSpecs: 'Escolha as especificações do produto',
    productAddedToBasketSuccessfully: 'O produto foi adicionado ao cesto!',
    goToBasket: 'Ir para o cesto',

    productRemoved: 'Produto removido',
    revoke: 'Anular',
    outOfStock: 'Esgotado',
    edit: 'Editar',
    remove: 'Remover',
    here: 'aqui',
    default: 'Predefinido',
    saveChanges: 'Guardar alterações',
    selectOption: 'Selecione uma opção',

    promotions: 'Promoções',
    onSale: 'Em promoção',
    endsIn: 'Termina em',

    defaultVehicle: 'Veículo predefinido',
    myVehicles: 'Os meus veículos',
    addNewVehicle: 'Adicionar novo veículo',
    changeVehicle: 'Alterar veículo',
    licensePlate: 'Matrícula',
    mileage: 'Quilometragem',
    acquisitionYear: 'Ano de aquisição',
    electricCar: 'Carro elétrico',
    plugInHybrid: 'Híbrido plug-in',
    electricMotorcycle: 'Mota elétrica',

    hasDiscountCoupon: 'Tem um cupão de desconto?',
    discountCoupon: 'Cupão de desconto',
    exchagePointsForDiscounts: 'Trocar pontos por descontos!',
    haveXPoints: 'Tem {points} pontos para utilizar',
    shipping: 'Envio',
    calculatedOnCheckout: 'A ser calculado no checkout',
    coupon: 'Cupão',
    campaign: 'Campanha',
    checkOut: 'Finalizar compra',

    changeProductQuantityError: 'Não foi possível alterar a quantidade do produto. Atualize a página e tente novamente.',

    paymentMethod: 'Método de pagamento',
    confirmingPayment: 'A confirmar pagamento',
    inPreparation: 'Em preparação',
    inTransit: 'Em trânsito',
    delivered: 'Entregue',
    failedPayment: 'O seu pagamento falhou',
    cancelled: 'Cancelado',
    returned: 'Devolvido',
    invoice: 'Fatura',
    refunded: 'Reembolsado',
    shippingOrder: 'Encomenda',
    shippingOrders: 'Encomendas',
    updateOrder: 'Atualizar encomenda',
    fromDateToDate: 'De {from} a {to}',
    request: 'Pedido',
    items: 'Itens',
    purchaseMade: 'Realizado em',
    canceledRequest: 'Pedido cancelado',
    estimatedDelivery: 'Entrega estimada',
    tracking: 'Tracking',
    unknownState: 'Estado desconhecido',
    keepBuying: 'Continuar a comprar',

    chooseBrand: 'Escolha a marca',
    chooseModel: 'Escolha o modelo',
    chooseVersion: 'Escolha a versão',
    exclusiveDiscounts: 'Quer receber descontos exclusivos?',
    inputVehicleDetails: 'Basta inserir (opcional):',
    addVehicle: 'Adicionar veículo',

    monoPhase: 'Monofásico',
    triPhase: 'Trifásico',
    house: 'Moradia',
    flat: 'Apartamento',
    company: 'Empresa',
    other: 'Outros',
    skip: 'Saltar',
    electric: 'Elétrico',
    plugin: 'Plug-in',
    motorcycle: 'Mota',
    basedOnYourVehicle: 'Com base no seu veículo',
    slow: 'Lento',
    intermediate: 'Intermediário',
    fast: 'Rápido',
    indifferent: 'Indiferente',
    chargingSpeed: 'Velocidade de carregamento',
    endSession: 'Terminar sessão',

    privacyPolicy: 'Política de Privacidade',
    termsConditions: 'Termos e Condições',
    conflictResolution: 'Resolução de Conflitos',

    notifications: 'Notificações',
    cashback: 'Cashback',
    cashbackAcc: 'Vai ganhar cashback de {amount} euros',
    chooseWallet: 'Escolher carteira',
    wallet: 'Carteira',
    balance: 'Saldo',
    prePayment: 'Pré-pagamento',
    postPayment: 'Pós-pagamento',
    businessWallet: 'Empresarial',
    personalWallet: 'Pessoal',
    walletBlockedPayment: 'Não é possível realizar o pagamento com a carteira selecionada, uma vez que a mesma ficou bloqueada.',
    walletNoBalance: 'Não é possível realizar o pagamento com a carteira selecionada, uma vez que a mesma ficou sem saldo suficiente.',

    entity: 'Entidade',
    reference: 'Referência'
  },
  en: {
    loading: 'Loading...',
    orderSuccess: 'Order placed successfully!',
    orderError: 'An error occurred while placing the order.',

    somethingWentWrong: 'Something went wrong',
    tryAgainLater: 'Please try again later',
    errorOccurred: 'An error occurred',
    tryAgain: 'Try again',
    content: 'Content',

    signInOrCreate: 'Sign in or create an account',
    signInOrCreateDescription: 'Save your favourite products, payment methods, shipping addresses and much more!',
    vehiclesAdded: 'Vehicles added',

    addToFavouritesTitle: 'Error adding to favorites',

    incorrectPassword: 'Incorrect password',
    enterEmailAndPasswordCorrectly: 'Please enter the email and password correctly.',

    myAccount: 'My account',
    createAnAccount: 'Create an account',
    accountDoesNotExist: 'Account does not exist',
    emaildDoesNotExist: 'The email entered does not correspond to an existing account. Click on Register or use Google, Facebook or Apple to log in.',

    alreadyExistingEmail: 'Email already exists',
    alreadyRegisteredEmail: 'The email entered is already registered. Check if you already have an account with one of the other options (Google, Facebook or Apple).',

    networkError: 'Network error',
    makeSureConnectedToInternet: 'Make sure you are connected to the internet. If the problem persists, try again later.',
    mbwayMandateError: 'It was not possible to add this number to the authorized MB WAY payments.',

    accountAlreadyExists: 'Account already exists',
    accountAlreadyExistsLoginThere: 'There is already an account associated with another login option. Please log in to that other account.',

    invalidCode: 'Invalid code',
    codeNotValidatedTryAgain: 'The code entered is invalid. Please try again.',
    invalidPostalCode: 'Invalid postal code',
    invalidEmail: 'Invalid email',

    loginAgain: 'Log in again',
    thisActionRequiresARecentLogin: 'This action requires you to log in again.',

    popUpClosedByUser: 'The popup was closed by the user.',
    accessCredentialsAlreadyInUseByAnotherAccount: 'Access credentials are already in use by another account.',
    phoneNumberAlreadyInUseByAnotherAccount: 'Phone number already in use by another account',

    smsCodeExpired: 'SMS code expired',
    smsCodeExpiredTryAgain: 'The SMS code has expired. Please request a new one and try again.',

    tooManyRequests: 'Too many requests',
    tooManyRequestsTryAgainLater: 'We have blocked all requests from this device due to suspicious activity. Please try again later.',

    invalidPhoneNumber: 'Invalid phone number',
    invalidPhoneNumberTryAgain: 'The phone number entered is invalid. Please check that you have entered the correct number and try again.',

    unsupportedNumber: 'Unsupported number',
    mobileNumberCountryNotSupported: "We're sorry, but the mobile number from this country is not yet supported.",

    name: 'Name',
    phoneNumber: 'Phone number',
    phone: 'Phone',
    password: 'Password',
    forgotPassword: 'Forgot password',
    insertValidName: 'Please enter a valid name',
    insertValidEmail: 'Please enter a valid email',
    insertValidPhoneNumber: 'Please enter a valid phone number',
    password6Characters: 'The password must be at least 6 characters long',
    validUntil: 'Valid until',
    until: 'Until',
    workingDays: 'Working days',
    onTheBasket: 'On the basket',

    terms1: 'I have read and accept the &lt;span&gt;Terms and Conditions&lt;/span&gt; of use of the miio application.',
    terms2: 'I have read, understand, and accept the conditions of use of the &lt;span&gt;electric mobility network&lt;/span&gt;.',
    terms3: "I have read, understand, and accept the general conditions of &lt;span&gt;electricity supply&lt;/span&gt; for miio's electric mobility.",

    countryOfResidence: 'Country of residence',
    yourData: 'Your data',
    hello: 'Hello',
    image: 'Image',
    changeImage: 'Change image',
    start: 'Start',
    end: 'End',
    attention: 'Attention',
    warning: 'Warning',

    enter: 'Enter',
    confirm: 'Confirm',
    confirmation: 'Confirmation',
    close: 'Close',
    closed: 'Closed',
    cancel: 'Cancel',
    cancelChange: 'Cancel change',
    keepChange: 'Keep change',
    search: 'Search',
    clear: 'Clear',
    apply: 'Apply',
    change: 'Change',
    status: 'Status',
    back: 'Go back',
    backToHomePage: 'Back to home page',
    advance: 'Advance',
    add: 'Add',
    or: 'or',
    country: 'Country',
    locality: 'Locality',
    postalCode: 'Postal Code',
    address: 'Address',
    number: 'Number',
    batch: 'Batch',
    optional: 'Optional',
    options: 'Options',
    saveAsDefault: 'Save as default',
    addNewAddress: 'Add new address',
    shippingAddress: 'Shipping address',
    savedAddresses: 'Saved addresses',
    defaultAddress: 'Default address',
    addShippingAddress: 'Add shipping address',
    vatAddress: 'Billing address',
    sameAsShippingAddress: 'Same as shipping address',
    noAddressesAdded: 'You do not have any addresses yet.',
    vat: 'VAT',
    vatNumber: 'VAT number',
    errorNoAddressOnAccount: 'There is no address associated with your miio account. Please add an address to continue. Please update your account information or create a billing address manually.',
    addShippingError: 'Could not associate shipping information. Please try again.',
    payment: 'Payment',
    doPayment: 'Make payment',
    goToPayment: 'Go to payment',
    paymentMethods: 'Payment methods',
    addNewMethod: 'Add new method',
    noPaymentMethods: 'You do not have any payment methods yet.',
    invoiceName: 'Name in invoice',
    wantToBeInvoicedAsFinalConsumer: 'I want an invoice without VAT ID',
    invoiceAsFinalConsumer: 'I want to be invoiced as a final consumer',
    invoicingEmail: 'Invoicing email',
    streetOrAvenue: 'Street or avenue',
    fillAllFields: 'Please fill in all fields marked with an *.',
    fromPrice: 'From',
    continue: 'Continue',
    yes: 'Yes',
    no: 'No',
    help: 'Help',
    faq: 'Frequently asked questions',
    speakWithMiio: 'Speak with miio',

    login: 'Log in',
    register: 'Register',
    month: 'Month',
    year: 'Year',

    basket: 'Basket',
    resume: 'Resume',
    compatible: 'Compatible',
    addToBasket: 'Add to basket',
    notAvailable: 'Not available',
    points: 'Points',
    favourites: 'Favorites',
    quantity: 'Quantity',
    yourRequest: 'Your request',
    helpContactSubject: 'Help with order #{id}',
    contactSupport: 'Contact support',

    allProducts: 'All products',
    suggestions: 'Our suggestions',
    bestsellers: 'Bestsellers',
    recentlySeen: 'Recently seen',
    viewMore: 'View more',
    viewLess: 'View less',
    commentUsefulToPeople: 'This comment was useful to {votes} people',
    loadMoreReviews: 'Load more reviews',
    loadPreviousProducts: 'View previous products',
    loadMoreProducts: 'Load more products',
    useful: 'Useful',
    mostUseful: 'Most useful',
    mostRecent: 'Most recent',
    ratings: 'Ratings',
    viewResults: 'View results',
    viewDetails: 'View details',
    chargingPreferences: 'Charging preferences',
    aboutUs: 'About us',
    value: 'Value',

    products: 'Products',
    noProducts: 'No products',
    noCategories: 'No categories',
    noRatings: 'No ratings',
    refreshPage: 'Refresh the page to try again',
    categories: 'Categories',
    filters: 'Filters',
    bestseller: 'Most sold',
    recommended: 'Recommended',
    recommendedSingular: 'Recommended',
    priceAsc: 'Price: Low to high',
    priceDesc: 'Price: High to low',
    priceWithoutDiscount: 'Price without discount',
    order: 'Order',
    orderBy: 'Order by',
    compare: 'Compare',
    compareProducts: 'Compare products',
    update: 'Update',
    nothingHere: 'There is nothing here',
    noCategoryProducts: 'There are no products in this category yet.',
    knowProductComments: 'To know what the community says about this product, click below.',
    problemLoadingProduct: 'There was a problem loading the product.',
    loadingCompareNotPossible: 'It was not possible to load the comparisons.',
    upsResultNotFound: 'Ups, no results found.',
    removeSearchKeywords: 'Try removing some of the keywords to see more results.',
    emptyBasket: 'Your basket is empty',
    emptyBasketDescription: 'Add products to make them appear here.',
    nothingToSeeHere: "For now, there's nothing to see here",
    addProductsToFavourites: 'Add products to your favorites list for quick access.',
    noOrdersPlaceholder: 'As soon as you make purchases, we will keep a record of them here.',

    timeToRecharge: 'Time to recharge',
    chargingFrom20to80: 'The charging time refers to 20% to 80% of the battery',
    inStock: 'In stock',
    lastUnits: 'Last units',
    limitedStock: 'Stock limited to {units} units, review the quantity to proceed.',
    remindMeWhenAvailable: 'Remind me when available',
    willBeNotifiedWhenAvailable: 'You will be notified as soon as this product is available again.',
    remindMe: 'Remind me',
    youCouldLike: 'You could also like:',
    description: 'Description',
    technicalDetails: 'Technical details',
    additionalInfo: 'Additional information',
    reviews: 'Reviews',
    historic: 'Historic',
    report: 'Report',
    reportReview: 'Report review',
    couponSuccess: 'Coupon applied successfully!',
    couponError: 'This coupon is not valid or has expired.',

    shippingDateAprox: 'Delivery forecast for {country}:',
    chooseDateToViewShippingDate: 'Choose the product specifications to see a more accurate delivery forecast.',
    chooseProductSpecs: 'Choose product specifications',
    productAddedToBasketSuccessfully: 'The product has been added to the basket!',
    goToBasket: 'Go to basket',

    productRemoved: 'Product removed',
    revoke: 'Revoke',
    outOfStock: 'Out of stock',
    edit: 'Edit',
    remove: 'Remove',
    here: 'here',
    default: 'Default',
    saveChanges: 'Save changes',
    selectOption: 'Select an option',

    promotions: 'Promotions',
    onSale: 'On sale',
    endsIn: 'Ends in',

    defaultVehicle: 'Default vehicle',
    myVehicles: 'My vehicles',
    addNewVehicle: 'Add new vehicle',
    changeVehicle: 'Change vehicle',
    licensePlate: 'License plate',
    mileage: 'Mileage',
    acquisitionYear: 'Acquisition year',
    electricCar: 'Electric car',
    plugInHybrid: 'Plug-in hybrid',
    electricMotorcycle: 'Electric motorcycle',

    hasDiscountCoupon: 'Do you have a discount coupon?',
    discountCoupon: 'Discount coupon',
    exchagePointsForDiscounts: 'Exchange points for discounts',
    haveXPoints: 'You have {points} points to use',
    shipping: 'Shipping',
    calculatedOnCheckout: 'Calculated on checkout',
    coupon: 'Coupon',
    campaign: 'Campaign',
    checkOut: 'Checkout',

    changeProductQuantityError: 'There was an error changing the quantity of the product. Refresh the page and try again.',

    paymentMethod: 'Payment Method',
    confirmingPayment: 'Confirming Payment',
    inPreparation: 'In Preparation',
    inTransit: 'In Transit',
    delivered: 'Delivered',
    failedPayment: 'Your Payment Failed',
    cancelled: 'Cancelled',
    returned: 'Returned',
    invoice: 'Invoice',
    refunded: 'Refunded',
    shippingOrder: 'Shipping Order',
    shippingOrders: 'Shipping Orders',
    updateOrder: 'Update Order',
    fromDateToDate: 'From {from} to {to}',
    request: 'Request',
    items: 'Items',
    purchaseMade: 'Purchase Made On',
    canceledRequest: 'Cancelled Request',
    estimatedDelivery: 'Estimated Delivery',
    tracking: 'Tracking',
    unknownState: 'Unknown State',
    keepBuying: 'Keep buying',

    chooseBrand: 'Choose the brand',
    chooseModel: 'Choose the model',
    chooseVersion: 'Choose the version',
    exclusiveDiscounts: 'Want to receive exclusive discounts?',
    inputVehicleDetails: 'Just enter (optional):',
    addVehicle: 'Add vehicle',

    monoPhase: 'Single-phase',
    triPhase: 'Three-phase',
    house: 'House',
    flat: 'Flat',
    company: 'Company',
    other: 'Other',
    skip: 'Skip',
    electric: 'Electric',
    plugin: 'Plug-in',
    motorcycle: 'Motorcycle',
    basedOnYourVehicle: 'Based on your vehicle',
    slow: 'Slow',
    intermediate: 'Intermediate',
    fast: 'Fast',
    indifferent: 'Indifferent',
    chargingSpeed: 'Charging speed',
    endSession: 'End session',

    privacyPolicy: 'Privacy Policy',
    termsConditions: 'Terms and Conditions',
    conflictResolution: 'Conflict Resolution',

    notifications: 'Notifications',
    cashback: 'Cashback',
    cashbackAcc: 'You will earn cashback of {amount} euros',
    chooseWallet: 'Choose wallet',
    wallet: 'Wallet',
    balance: 'Balance',
    prePayment: 'Pre-payment',
    postPayment: 'Post-payment',
    businessWallet: 'Business',
    personalWallet: 'Personal',
    walletBlockedPayment: 'It is not possible to make the payment with the selected wallet, as it has been blocked.',
    walletNoBalance: 'It is not possible to make the payment with the selected wallet, as it has run out of balance.',

    entity: 'Entity',
    reference: 'Reference'
  },
  es: {
    loading: 'Cargando...',
    orderSuccess: 'Pedido realizado con éxito!',
    orderError: 'Ocurrió un error al realizar el pedido.',

    somethingWentWrong: 'Algo salió mal',
    tryAgainLater: 'Por favor, inténtalo de nuevo más tarde',
    errorOccurred: 'Ocurrió un error',
    tryAgain: 'Inténtalo de nuevo',
    content: 'Contenido',

    signInOrCreate: 'Inicie sesión o cree una cuenta',
    signInOrCreateDescription: '¡Guarde sus productos favoritos, métodos de pago, direcciones de envío y mucho más!',
    vehiclesAdded: 'Vehículos añadidos',

    addToFavouritesTitle: 'Error al agregar a favoritos',

    incorrectPassword: 'Contraseña incorrecta',
    enterEmailAndPasswordCorrectly: 'Ingresa el correo y la contraseña correctamente.',

    myAccount: 'Mi cuenta',
    createAnAccount: 'Crear cuenta',
    accountDoesNotExist: 'Cuenta no existe',
    emaildDoesNotExist: 'El correo ingresado no corresponde a una cuenta existente. Haz clic en Registrarse o usa Google, Facebook o Apple para iniciar sesión.',

    alreadyExistingEmail: 'Correo ya existe',
    alreadyRegisteredEmail: 'El correo ingresado ya está registrado. Verifica si ya tienes una cuenta con una de las otras opciones (Google, Facebook o Apple).',

    networkError: 'Error de red',
    makeSureConnectedToInternet: 'Asegúrate de estar conectado a internet. Si el problema persiste, inténtalo de nuevo más tarde.',
    mbwayMandateError: 'No fue posible agregar este número a los pagos autorizados de MB WAY.',

    accountAlreadyExists: 'Cuenta ya existe',
    accountAlreadyExistsLoginThere: 'Ya existe una cuenta asociada con otra opción de inicio de sesión. Por favor, inicia sesión en esa otra cuenta.',

    invalidCode: 'Código inválido',
    codeNotValidatedTryAgain: 'El código ingresado es inválido. Por favor, inténtalo de nuevo.',
    invalidPostalCode: 'Código postal inválido',
    invalidEmail: 'Correo inválido',

    loginAgain: 'Iniciar sesión de nuevo',
    thisActionRequiresARecentLogin: 'Esta acción requiere que inicies sesión de nuevo.',

    popUpClosedByUser: 'El popup fue cerrado por el usuario.',
    accessCredentialsAlreadyInUseByAnotherAccount: 'Las credenciales de acceso ya están en uso por otra cuenta.',
    phoneNumberAlreadyInUseByAnotherAccount: 'El número de teléfono ya está en uso por otra cuenta',

    smsCodeExpired: 'Código SMS expirado',
    smsCodeExpiredTryAgain: 'El código SMS ha expirado. Por favor, solicita uno nuevo e inténtalo de nuevo.',

    tooManyRequests: 'Demasiados pedidos',
    tooManyRequestsTryAgainLater: 'Hemos bloqueado todos los pedidos de este dispositivo debido a una actividad sospechosa. Por favor, inténtalo de nuevo más tarde.',

    invalidPhoneNumber: 'Número de teléfono inválido',
    invalidPhoneNumberTryAgain: 'El número de teléfono ingresado es inválido. Por favor, verifica que hayas ingresado el número correcto e inténtalo de nuevo.',

    unsupportedNumber: 'Número no soportado',
    mobileNumberCountryNotSupported: 'Lo sentimos, pero el número de móvil de este país aún no está soportado.',

    name: 'Nombre',
    phoneNumber: 'Número de teléfono',
    phone: 'Teléfono',
    password: 'Contraseña',
    forgotPassword: 'Olvidé mi contraseña',
    insertValidName: 'Ingresa un nombre válido',
    insertValidEmail: 'Ingresa un correo válido',
    insertValidPhoneNumber: 'Ingresa un número de teléfono válido',
    password6Characters: 'La contraseña debe tener al menos 6 caracteres',
    validUntil: 'Válido hasta',
    until: 'Hasta',
    workingDays: 'Días hábiles',
    onTheBasket: 'En el carrito',

    terms1: 'He leído y acepto los &lt;span&gt;Términos y condiciones&lt;/span&gt; de uso de la aplicación miio.',
    terms2: 'He leído, comprendo y acepto las condiciones de uso de la &lt;span&gt;red de movilidad eléctrica&lt;/span&gt;.',
    terms3: 'He leído, comprendo y acepto las condiciones generales de &lt;span&gt;suministro de electricidad&lt;/span&gt; para la movilidad eléctrica de miio.',

    countryOfResidence: 'País de residencia',
    yourData: 'Tus datos',
    hello: 'Hola',
    image: 'Imagen',
    changeImage: 'Cambiar imagen',
    start: 'Inicio',
    end: 'Fin',
    attention: 'Atención',
    warning: 'Advertencia',

    enter: 'Ingresar',
    confirm: 'Confirmar',
    confirmation: 'Confirmación',
    close: 'Cerrar',
    closed: 'Cerrado',
    cancel: 'Cancelar',
    cancelChange: 'Cancelar cambio',
    keepChange: 'Mantener cambio',
    search: 'Buscar',
    clear: 'Limpiar',
    apply: 'Aplicar',
    change: 'Cambiar',
    status: 'Estado',
    back: 'Volver',
    backToHomePage: 'Volver a la página de inicio',
    advance: 'Avanzar',
    add: 'Agregar',
    or: 'o',
    country: 'País',
    locality: 'Localidad',
    postalCode: 'Código postal',
    address: 'Dirección',
    number: 'Número',
    batch: 'Lote',
    optional: 'Opcional',
    options: 'Opciones',
    saveAsDefault: 'Guardar como predeterminado',
    addNewAddress: 'Agregar nueva dirección',
    shippingAddress: 'Dirección de envío',
    savedAddresses: 'Direcciones guardadas',
    defaultAddress: 'Dirección predeterminada',
    addShippingAddress: 'Agregar dirección de envío',
    vatAddress: 'Dirección de facturación',
    sameAsShippingAddress: 'Igual que la dirección de envío',
    noAddressesAdded: 'No hay direcciones agregadas',
    vat: 'NIF',
    vatNumber: "Numéro d'identification fiscale",
    errorNoAddressOnAccount:
      'No hay ninguna dirección en tu cuenta miio. Por favor, agrega una dirección para continuar. Por favor, actualice la información de su cuenta o cree una dirección de facturación manualmente.',
    addShippingError: 'No se pudieron asociar los datos de envío. Por favor, inténtelo de nuevo.',
    payment: 'Pago',
    doPayment: 'Hacer pago',
    goToPayment: 'Ir al pago',
    paymentMethods: 'Métodos de pago',
    addNewMethod: 'Agregar nuevo método',
    noPaymentMethods: 'No hay métodos de pago',
    invoiceName: 'Nombre en la factura',
    wantToBeInvoicedAsFinalConsumer: 'Quiero factura sin NIF',
    invoiceAsFinalConsumer: 'Quiero ser facturado como consumidor final',
    invoicingEmail: 'Correo de facturación',
    streetOrAvenue: 'Calle o avenida',
    fillAllFields: 'Por favor, complete todos los campos marcados con un *.',
    fromPrice: 'Desde',
    continue: 'Continuar',
    yes: 'Sí',
    no: 'No',
    help: 'Ayuda',
    faq: 'Preguntas frecuentes',
    speakWithMiio: 'Hablar con miio',

    login: 'Iniciar sesión',
    register: 'Registrarse',
    month: 'Mes',
    year: 'Año',

    basket: 'Carrito',
    resume: 'Resumen',
    compatible: 'Compatible',
    addToBasket: 'Agregar al carrito',
    notAvailable: 'No disponible',
    points: 'Puntos',
    favourites: 'Favoritos',
    quantity: 'Cantidad',
    yourRequests: 'Tus pedidos',
    helpContactSubject: 'Ayuda con el pedido #{id}',
    contactSupport: 'Contactar soporte',

    allProducts: 'Todos los productos',
    suggestions: 'Nuestras sugerencias',
    bestsellers: 'Más vendidos',
    recommended: 'Recomendados',
    recommendedSingular: 'Recomendado',
    recentlySeen: 'Vistos recientemente',
    viewMore: 'Ver más',
    viewLess: 'Ver menos',
    commentUsefulToPeople: 'Este comentario fue útil para {votes} personas',
    loadMoreReviews: 'Cargar más comentarios',
    loadPreviousProducts: 'Ver productos anteriores',
    loadMoreProducts: 'Cargar más productos',
    useful: 'Útil',
    mostUseful: 'Más útiles',
    mostRecent: 'Más recientes',
    ratings: 'Calificaciones',
    viewResults: 'Ver resultados',
    viewDetails: 'Ver detalles',
    chargingPreferences: 'Preferencias de carga',
    aboutUs: 'Sobre nosotros',
    value: 'Valor',

    products: 'Productos',
    noProducts: 'No hay productos',
    noCategories: 'No hay categorías',
    noRatings: 'No hay calificaciones',
    refreshPage: 'Actualiza la página para intentarlo de nuevo',
    categories: 'Categorías',
    filters: 'Filtros',
    bestseller: 'Más vendidos',
    priceAsc: 'Precio: Menor a mayor',
    priceDesc: 'Precio: Mayor a menor',
    priceWithoutDiscount: 'Precio sin descuento',
    order: 'Ordenar',
    orderBy: 'Ordenar por',
    compare: 'Comparar',
    compareProducts: 'Comparar productos',
    update: 'Actualizar',
    nothingHere: 'No hay nada aquí',
    noCategoryProducts: 'Aún no hay productos en esta categoría.',
    knowProductComments: 'Para saber lo que dice la comunidad sobre este producto, haz clic abajo.',
    problemLoadingProduct: 'Hubo un problema cargando el producto.',
    loadingCompareNotPossible: 'Hubo un problema cargando los productos.',
    upsResultNotFound: 'No se encontraron resultados para tu búsqueda.',
    removeSearchKeywords: 'Elimina o cambia las palabras clave para obtener mejores resultados.',
    emptyBasket: 'Tu cesta está vacía',
    emptyBasketDescription: 'Agrega productos para que aparezcan aquí.',
    nothingToSeeHere: 'Por ahora, no hay nada que ver aquí',
    addProductsToFavourites: 'Agrega productos a tu lista de favoritos para un acceso rápido.',
    noOrdersPlaceholder: 'Tan pronto como realices compras, las guardaremos aquí.',

    timeToRecharge: 'Tiempo de recarga',
    chargingFrom20to80: 'El tiempo de recarga se refiere al 20% al 80% de la batería',
    inStock: 'En stock',
    lastUnits: 'Últimas unidades',
    limitedStock: 'Stock limitado a {units} unidades, revisa la cantidad para proceder.',
    remindMeWhenAvailable: 'Recordarme cuando esté disponible',
    willBeNotifiedWhenAvailable: 'Se te notificará tan pronto como este producto esté disponible nuevamente.',
    remindMe: 'Recordarme',
    youCouldLike: 'También te podría gustar:',
    description: 'Descripción',
    technicalDetails: 'Detalles técnicos',
    additionalInfo: 'Información adicional',
    reviews: 'Reseñas',
    historic: 'Histórico',
    report: 'Reportar',
    reportReview: 'Reportar comentario',
    couponSuccess: '¡Cupón aplicado con éxito!',
    couponError: 'Este cupón no es válido o ha expirado.',

    shippingDateAprox: 'Previsión de entrega para {country}:',
    chooseDateToViewShippingDate: 'Seleccione las especificaciones del producto para ver una previsión de entrega más precisa.',
    chooseProductSpecs: 'Elija las especificaciones del producto',
    productAddedToBasketSuccessfully: '¡El producto ha sido añadido al carrito!',
    goToBasket: 'Ir al carrito',

    productRemoved: 'Producto eliminado',
    revoke: 'Anular',
    outOfStock: 'Agotado',
    edit: 'Editar',
    remove: 'Remover',
    here: 'aquí',
    default: 'Predeterminado',
    saveChanges: 'Guardar cambios',
    selectOption: 'Selecciona una opción',

    promotions: 'Promociones',
    onSale: 'En promoción',
    endsIn: 'Termina en',

    defaultVehicle: 'Vehículo predeterminado',
    myVehicles: 'Mis vehículos',
    addNewVehicle: 'Agregar nuevo vehículo',
    changeVehicle: 'Cambiar vehículo',
    licensePlate: 'Matrícula',
    mileage: 'Kilometraje',
    acquisitionYear: 'Año de adquisición',
    electricCar: 'Coche eléctrico',
    plugInHybrid: 'Híbrido enchufable',
    electricMotorcycle: 'Motocicleta eléctrica',

    hasDiscountCoupon: 'Tiene un cupón de descuento?',
    discountCoupon: 'Cupón de descuento',
    exchagePointsForDiscounts: 'Intercambia tus puntos por descuentos',
    haveXPoints: 'Tienes {points} puntos para utilizar',
    shipping: 'Envío',
    calculatedOnCheckout: 'Calculado en el checkout',
    coupon: 'Cupón',
    campaign: 'Campaña',
    checkOut: 'Checkout',

    changeProductQuantityError: 'Hubo un problema cambiando la cantidad del producto. Por favor, inténtalo de nuevo.',

    paymentMethod: 'Método de Pago',
    confirmingPayment: 'Confirmando Pago',
    inPreparation: 'En Preparación',
    inTransit: 'En Tránsito',
    delivered: 'Entregado',
    failedPayment: 'Su Pago Falló',
    cancelled: 'Cancelado',
    returned: 'Devuelto',
    invoice: 'Factura',
    refunded: 'Reintegrado',
    shippingOrder: 'Orden de Envío',
    shippingOrders: 'Órdenes de Envío',
    updateOrder: 'Actualizar Orden',
    fromDateToDate: 'De {from} a {to}',
    request: 'Pedido',
    items: 'Artículos',
    purchaseMade: 'Realizado en',
    canceledRequest: 'Pedido Cancelado',
    estimatedDelivery: 'Entrega Estimada',
    tracking: 'Seguimiento',
    unknownState: 'Estado Desconocido',
    keepBuying: 'Seguir comprando',

    chooseBrand: 'Elija la marca',
    chooseModel: 'Elija el modelo',
    chooseVersion: 'Elija la versión',
    exclusiveDiscounts: '¿Quieres recibir descuentos exclusivos?',
    inputVehicleDetails: 'Basta con introducir (opcional):',
    addVehicle: 'Añadir vehículo',

    monoPhase: 'Monofásico',
    triPhase: 'Trifásico',
    house: 'Casa',
    flat: 'Piso',
    company: 'Empresa',
    other: 'Otros',
    skip: 'Saltar',
    electric: 'Eléctrico',
    plugin: 'Plug-in',
    motorcycle: 'Moto',
    basedOnYourVehicle: 'Basado en tu vehículo',
    slow: 'Lento',
    intermediate: 'Intermedio',
    fast: 'Rápido',
    indifferent: 'Indiferente',
    chargingSpeed: 'Velocidad de carga',
    endSession: 'Finalizar sesión',

    privacyPolicy: 'Política de Privacidad',
    termsConditions: 'Términos y Condiciones',
    conflictResolution: 'Resolución de Conflictos',

    notifications: 'Notificaciones',
    cashback: 'Cashback',
    cashbackAcc: 'Vas a ganar cashback de {amount} euros',
    chooseWallet: 'Elegir billetera',
    wallet: 'Billetera',
    balance: 'Saldo',
    prePayment: 'Pre-pago',
    postPayment: 'Post-pago',
    businessWallet: 'Empresarial',
    personalWallet: 'Personal',
    walletBlockedPayment: 'No es posible realizar el pago con la billetera seleccionada, ya que ha sido bloqueada.',
    walletNoBalance: 'No es posible realizar el pago con la billetera seleccionada, ya que se ha quedado sin saldo.',

    entity: 'Entidad',
    reference: 'Referencia'
  },
  fr: {
    loading: 'Chargement...',
    orderSuccess: 'Commande passée avec succès!',
    orderError: 'Une erreur s est produite lors de la commande.',

    somethingWentWrong: "Une erreur s'est produite",
    tryAgainLater: 'Veuillez réessayer plus tard',
    errorOccurred: 'Une erreur s est produite',
    tryAgain: 'Veuillez réessayer',
    content: 'Contenu',

    signInOrCreate: 'Connectez-vous ou créez un compte',
    signInOrCreateDescription: 'Enregistrez vos produits préférés, vos modes de paiement, vos adresses de livraison et bien plus encore !',
    vehiclesAdded: 'Véhicules ajoutés',

    addToFavouritesTitle: 'Erreur lors de l ajout aux favoris',

    incorrectPassword: 'Mot de passe incorrect',
    enterEmailAndPasswordCorrectly: "Veuillez saisir correctement l'e-mail et le mot de passe.",

    myAccount: 'Mon compte',
    createAnAccount: 'Créer un compte',
    accountDoesNotExist: "Le compte n'existe pas",
    emaildDoesNotExist: "L'adresse e-mail saisie ne correspond pas à un compte existant. Cliquez sur S'inscrire ou utilisez Google, Facebook ou Apple pour vous connecter.",

    alreadyExistingEmail: 'Adresse e-mail déjà existante',
    alreadyRegisteredEmail: "L'adresse e-mail saisie est déjà enregistrée. Vérifiez si vous avez déjà un compte avec l'une des autres options (Google, Facebook ou Apple).",

    networkError: 'Erreur de réseau',
    makeSureConnectedToInternet: "Assurez-vous d'être connecté à Internet. Si le problème persiste, réessayez plus tard.",
    mbwayMandateError: "Il n'a pas été possible d'ajouter ce numéro aux paiements MB WAY autorisés.",

    accountAlreadyExists: 'Le compte existe déjà',
    accountAlreadyExistsLoginThere: 'Il existe déjà un compte associé à une autre option de connexion. Veuillez vous connecter à cet autre compte.',

    invalidCode: 'Code invalide',
    codeNotValidatedTryAgain: 'Le code saisi est invalide. Veuillez réessayer.',
    invalidPostalCode: 'Code postal invalide',
    invalidEmail: 'Adresse e-mail invalide',

    loginAgain: 'Se connecter à nouveau',
    thisActionRequiresARecentLogin: 'Cette action nécessite que vous vous connectiez à nouveau.',

    popUpClosedByUser: "La fenêtre pop-up a été fermée par l'utilisateur.",
    accessCredentialsAlreadyInUseByAnotherAccount: "Les informations d'identification d'accès sont déjà utilisées par un autre compte.",
    phoneNumberAlreadyInUseByAnotherAccount: 'Numéro de téléphone déjà utilisé par un autre compte',

    smsCodeExpired: 'Le code SMS a expiré',
    smsCodeExpiredTryAgain: 'Le code SMS a expiré. Veuillez en demander un nouveau et réessayer.',

    tooManyRequests: 'Trop de demandes',
    tooManyRequestsTryAgainLater: "Nous avons bloqué toutes les demandes de cet appareil en raison d'une activité suspecte. Veuillez réessayer plus tard.",

    invalidPhoneNumber: 'Numéro de téléphone invalide',
    invalidPhoneNumberTryAgain: 'Le numéro de téléphone saisi est invalide. Veuillez vérifier que vous avez entré le bon numéro et réessayez.',

    unsupportedNumber: 'Numéro non pris en charge',
    mobileNumberCountryNotSupported: "Nous sommes désolés, mais le numéro de mobile de ce pays n'est pas encore pris en charge.",

    name: 'Nom',
    phoneNumber: 'Numéro de téléphone',
    phone: 'Téléphone',
    password: 'Mot de passe',
    forgotPassword: "J'ai oublié mon mot de passe",
    insertValidName: 'Veuillez saisir un nom valide',
    insertValidEmail: 'Veuillez saisir une adresse e-mail valide',
    insertValidPhoneNumber: 'Veuillez saisir un numéro de téléphone valide',
    password6Characters: 'Le mot de passe doit contenir au moins 6 caractères',
    validUntil: 'Valide jusqu au',
    until: 'Jusqu au',
    workingDays: 'Jours ouvrables',
    onTheBasket: 'Sur le panier',

    terms1: "J'ai lu et j'accepte les &lt;span&gt;termes et conditions&lt;/span&gt; d'utilisation de l'application miio.",
    terms2: "J'ai lu, compris et j'accepte les conditions d'utilisation de la &lt;span&gt;mobilité électrique&lt;/span&gt;.",
    terms3: "J'ai lu, compris et j'accepte les conditions générales de &lt;span&gt;fourniture d'électricité&lt;/span&gt; pour la mobilité électrique de miio.",

    countryOfResidence: 'Pays de résidence',
    yourData: 'Vos données',
    hello: 'Bonjour',
    image: 'Image',
    changeImage: 'Changer l image',
    start: 'Démarrer',
    end: 'Fin',
    attention: 'Attention',
    warning: 'Avertissement',

    enter: 'Entrer',
    confirm: 'Confirmer',
    confirmation: 'Confirmation',
    close: 'Fermer',
    closed: 'Fermé',
    cancel: 'Annuler',
    cancelChange: 'Annuler le changement',
    keepChange: 'Conserver le changement',
    search: 'Rechercher',
    clear: 'Effacer',
    apply: 'Appliquer',
    change: 'Changer',
    status: 'Statut',
    back: 'Retour',
    backToHomePage: 'Retour à la page d accueil',
    advance: 'Avance',
    add: 'Ajouter',
    or: 'ou',
    country: 'Pays',
    locality: 'Localité',
    postalCode: 'Code postal',
    address: 'Adresse',
    number: 'Numéro',
    batch: 'Lot',
    optional: 'Optionnel',
    options: 'Options',
    saveAsDefault: 'Enregistrer comme défaut',
    addNewAddress: 'Ajouter une nouvelle adresse',
    shippingAddress: 'Adresse de livraison',
    savedAddresses: 'Adresses enregistrées',
    defaultAddress: 'Adresse par défaut',
    addShippingAddress: 'Ajouter une adresse de livraison',
    vatAddress: 'Adresse de facturation',
    sameAsShippingAddress: 'Même adresse de livraison',
    noAddressesAdded: 'Aucune adresse ajoutée',
    vat: 'TVA',
    vatNumber: 'Numéro fiscal',
    errorNoAddressOnAccount:
      'Aucune adresse n a été trouvée sur votre compte. Veuillez en ajouter une pour continuer. Veuillez mettre à jour les informations de votre compte ou créer une adresse de facturation manuellement.',
    addShippingError: "Impossible d'associer les informations d'expédition. Veuillez réessayer.",
    payment: 'Paiement',
    doPayment: 'Effectuer le paiement',
    goToPayment: 'Aller au paiement',
    paymentMethods: 'Méthodes de paiement',
    addNewMethod: 'Ajouter une nouvelle méthode',
    noPaymentMethods: 'Aucune méthode de paiement ajoutée',
    invoiceName: 'Nom sur la facture',
    wantToBeInvoicedAsFinalConsumer: 'Je veux une facture sans numéro de TVA',
    invoiceAsFinalConsumer: 'Je veux être facturé en tant que consommateur final',
    invoicingEmail: 'Adresse e-mail de facturation',
    streetOrAvenue: 'Rue ou avenue',
    fillAllFields: "Veuillez remplir tous les champs marqués d'un *.",
    fromPrice: 'Dès',
    continue: 'Continuer',
    yes: 'Oui',
    no: 'Non',
    help: 'Aide',
    faq: 'Questions fréquentes',
    speakWithMiio: 'Parler avec miio',

    login: 'Se connecter',
    register: "S'inscrire",
    month: 'Mois',
    year: 'Année',

    basket: 'Panier',
    resume: 'Résumé',
    compatible: 'Compatible',
    addToBasket: 'Ajouter au panier',
    notAvailable: 'Non disponible',
    points: 'Points',
    favourites: 'Favoris',
    quantity: 'Quantité',
    yourRequests: 'Vos demandes',
    helpContactSubject: 'Aide avec la commande #{id}',
    contactSupport: 'Contacter le support',

    allProducts: 'Tous les produits',
    suggestions: 'Nos suggestions',
    bestsellers: 'Meilleures ventes',
    recentlySeen: 'Récemment vu',
    viewMore: 'Voir plus',
    viewLess: 'Voir moins',
    commentUsefulToPeople: 'Cette opinion a été utile à {votes} personnes',
    loadMoreReviews: 'Charger plus d’avis',
    loadPreviousProducts: 'Voir les produits précédents',
    loadMoreProducts: 'Charger plus de produits',
    useful: 'Utile',
    mostUseful: 'Le plus utile',
    mostRecent: 'Le plus récent',
    ratings: 'Évaluations',
    viewResults: 'Voir les résultats',
    viewDetails: 'Voir les détails',
    chargingPreferences: 'Préférences de charge',
    aboutUs: 'À propos de nous',
    value: 'Valeur',

    products: 'Produits',
    noProducts: 'Aucun produit',
    noCategories: 'Aucune catégorie',
    noRatings: 'Aucune évaluation',
    refreshPage: 'Actualisez la page pour réessayer',
    categories: 'Catégories',
    filters: 'Filtres',
    bestseller: 'Meilleures ventes',
    recommended: 'Recommandé',
    recommendedSingular: 'Recommandé',
    priceAsc: 'Prix: du plus bas au plus élevé',
    priceDesc: 'Prix: du plus élevé au plus bas',
    priceWithoutDiscount: 'Prix sans réduction',
    order: 'Commander',
    orderBy: 'Trier par',
    compare: 'Comparer',
    compareProducts: 'Comparer les produits',
    update: 'Mettre à jour',
    nothingHere: 'Rien ici',
    noCategoryProducts: 'Il n’y a pas encore de produits dans cette catégorie.',
    knowProductComments: 'Il n’y a pas encore de produits pour cette recherche.',
    problemLoadingProduct: 'Aucun produit trouvé',
    loadingCompareNotPossible: 'Aucune catégorie trouvée',
    upsResultNotFound: 'Aucun résultat trouvé',
    removeSearchKeywords: 'Supprimer les mots-clés de recherche',
    emptyBasket: 'Votre panier est vide',
    emptyBasketDescription: 'Ajoutez des produits pour les faire apparaître ici.',
    nothingToSeeHere: "Pour le moment, il n'y a rien à voir ici",
    addProductsToFavourites: 'Ajoutez des produits à votre liste de favoris pour un accès rapide.',
    noOrdersPlaceholder: 'Dès que vous effectuez des achats, nous les enregistrons ici.',

    timeToRecharge: 'Temps de recharge',
    chargingFrom20to80: 'Le temps de recharge fait référence à 20% à 80% de la batterie',
    inStock: 'En stock',
    lastUnits: 'Dernières unités',
    limitedStock: 'Stock limité à {units} unités, vérifiez la quantité pour continuer.',
    remindMeWhenAvailable: 'Rappelez-moi quand il sera disponible',
    willBeNotifiedWhenAvailable: 'Vous serez averti dès que ce produit sera à nouveau disponible.',
    remindMe: 'Rappelez-moi',
    youCouldLike: 'Vous pourriez aussi aimer:',
    description: 'Description',
    technicalDetails: 'Détails techniques',
    additionalInfo: 'Informations supplémentaires',
    reviews: 'Commentaires',
    historic: 'Historique',
    report: 'Signaler',
    reportReview: 'Signaler un commentaire',
    couponSuccess: 'Coupon appliqué avec succès !',
    couponError: 'Ce coupon n`est pas valide ou a expiré.',

    shippingDateAprox: 'Prévision de livraison pour {country} :',
    chooseDateToViewShippingDate: 'Choisissez les spécifications du produit pour voir une prévision de livraison plus précise.',
    chooseProductSpecs: 'Choisissez les spécifications du produit',
    productAddedToBasketSuccessfully: 'Le produit a été ajouté au panier !',
    goToBasket: 'Aller au panier',

    productRemoved: 'Produit supprimé',
    revoke: 'Annuler',
    outOfStock: 'En rupture de stock',
    edit: 'Modifier',
    remove: 'Supprimer',
    here: 'ici',
    default: 'Par défaut',
    saveChanges: 'Enregistrer les modifications',
    selectOption: 'Sélectionner une option',

    promotions: 'Promotions',
    onSale: 'En promotion',
    endsIn: 'Se termine dans',

    defaultVehicle: 'Véhicule par défaut',
    myVehicles: 'Mes véhicules',
    addNewVehicle: 'Ajouter un nouveau véhicule',
    changeVehicle: 'Changer de véhicule',
    licensePlate: 'Plaque d’immatriculation',
    mileage: 'Kilométrage',
    acquisitionYear: 'Année d’acquisition',
    electricCar: 'Voiture électrique',
    plugInHybrid: 'Hybride rechargeable',
    electricMotorcycle: 'Moto électrique',

    hasDiscountCoupon: 'Vous avez un coupon de réduction ?',
    discountCoupon: 'Coupon de réduction',
    exchagePointsForDiscounts: 'Échangez vos points contre des réductions',
    haveXPoints: 'Vous avez {points} points',
    shipping: 'Livraison',
    calculatedOnCheckout: 'Calculé lors du paiement',
    coupon: 'Coupon',
    campaign: 'Campagne',
    checkOut: 'Payer',

    changeProductQuantityError: 'Une erreur s’est produite lors de la modification de la quantité du produit. Veuillez réessayer.',

    paymentMethod: 'Moyen de Paiement',
    confirmingPayment: 'Confirmation de Paiement',
    inPreparation: 'En Préparation',
    inTransit: 'En Transit',
    delivered: 'Livré',
    failedPayment: 'Paiement Échoué',
    cancelled: 'Annulé',
    returned: 'Retourné',
    invoice: 'Facture',
    refunded: 'Remboursé',
    shippingOrder: "Ordre d'Expédition",
    shippingOrders: "Ordres d'Expédition",
    updateOrder: 'Mettre à jour la commande',
    fromDateToDate: 'De {from} à {to}',
    request: 'Demande',
    items: 'Articles',
    purchaseMade: 'Achat Effectué le',
    canceledRequest: 'Demande Annulée',
    estimatedDelivery: 'Livraison Estimée',
    tracking: 'Suivi',
    unknownState: 'État Inconnu',
    keepBuying: 'Continuer à acheter',

    chooseBrand: 'Choisissez la marque',
    chooseModel: 'Choisissez le modèle',
    chooseVersion: 'Choisissez la version',
    exclusiveDiscounts: 'Vous voulez recevoir des réductions exclusives?',
    inputVehicleDetails: "Il suffit d'entrer (facultatif):",
    addVehicle: 'Ajouter un véhicule',

    monoPhase: 'Monophasé',
    triPhase: 'Triphasé',
    house: 'Maison',
    flat: 'Appartement',
    company: 'Entreprise',
    other: 'Autre',
    skip: 'Passer',
    electric: 'Électrique',
    plugin: 'Plug-in',
    motorcycle: 'Moto',
    basedOnYourVehicle: 'Basé sur votre véhicule',
    slow: 'Lent',
    intermediate: 'Intermédiaire',
    fast: 'Rapide',
    indifferent: 'Indifférent',
    chargingSpeed: 'Vitesse de charge',
    endSession: 'Fermer la session',

    privacyPolicy: 'Politique de Confidentialité',
    termsConditions: 'Termes et Conditions',
    conflictResolution: 'Résolution des Conflits',

    notifications: 'Notifications',
    cashback: 'Cashback',
    cashbackAcc: 'Vous gagnerez un cashback de {amount} euros',
    chooseWallet: 'Choisir le portefeuille',
    wallet: 'Portefeuille',
    balance: 'Solde',
    prePayment: 'Pré-paiement',
    postPayment: 'Post-paiement',
    businessWallet: 'Entreprise',
    personalWallet: 'Personnel',
    walletBlockedPayment: "Il n'est pas possible de payer avec le portefeuille sélectionné, car il a été bloqué.",
    walletNoBalance: "Il n'est pas possible de payer avec le portefeuille sélectionné, car il n'a plus de solde.",

    entity: 'Entité',
    reference: 'Référence'
  }
}
